import { CPagesPath } from "./pages-path";
import BusinessIcon from "@mui/icons-material/Business";
import BookIcon from "@mui/icons-material/Book";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { useTranslations } from "next-intl";
import { INavLink } from "../interfaces/components/navlinks.interface";

export function useRemaxIntlNavLinks() {
  const translation = useTranslations("header");

  const CNavLinksRemaxRd: INavLink[] = [
    {
      slug: translation("agent"),
      link: CPagesPath.es.join,
      icon: PersonAddAlt1Icon,
    },
    {
      slug: translation("franchise"),
      link: CPagesPath.es.franchises,
      icon: BusinessIcon,
    },
    {
      slug: translation("blog"),
      link: CPagesPath.blog,
      icon: BookIcon,
      target: "_blank",
    },
    {
      slug: translation("contact"),
      link: "/contactanos",
      icon: AlternateEmailIcon,
    },
  ];

  return CNavLinksRemaxRd;
}

export const CNavLinksRemaxRd: INavLink[] = [
  {
    slug: "Sé un agente",
    link: CPagesPath.es.join,
    icon: PersonAddAlt1Icon,
  },
  {
    slug: "Adquiere una franquicia",
    link: CPagesPath.es.franchises,
    icon: BusinessIcon,
  },
  {
    slug: "Blog",
    link: CPagesPath.blog,
    icon: BookIcon,
    target: "_blank",
  },
  {
    slug: "Contáctanos",
    link: "/contactanos",
    icon: AlternateEmailIcon,
  },
];
